export default "__VITE_ASSET__8ctu_6bn__"